import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';

export const NotFoundPage = () => (
  <Stack spacing={2} sx={{ alignItems: 'flex-start', py: 4 }}>
    <Typography variant="h1">ページが見つかりません</Typography>
    <Button component={Link} to="/" variant="outlined">
      ダッシュボードへ戻る
    </Button>
  </Stack>
);
